import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { UiCommand } from '@ui/cer-ui-types';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';
import { baseUrlTrackTrace } from '../warehouse-outbound-order.service';

const onlySalesCmd: UiCommand = {
  id: 'onlySalesCmd', text: 'Vis alle', align: 'right',
  iconCss: "e-menu-icon e-icons e-circle-check", tooltipText: 'Vis kun salg', target: ".e-content", visible: true
};

export class WarehouseOutboundDispatchTransForm extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({

      toolbarCommands: [onlySalesCmd],
      viewMetadata: {
        name: 'lager-afsendte', dataApiName: 'WarehouseOutboundOrderDispatch', text: 'Afsendte', textSingular: 'Afsendt',
        primaryKey: 'pickOrderNum', allowEdit: false, allowCreate: false, allowDelete: false
      },
      fieldMetadata: [
        { name: 'deliveryDate', text: 'Afsendelsesdato', format: 'DateShort', orderBy: 'Descending', orderByPriority: 1 },
        { name: 'outboundOrderNum', text: 'Forsendelse', foreignKeyType: 'warehouseOutboundOrderLookup' ,widthType: FieldWidthEnum.XS, orderBy: 'Descending', orderByPriority: 2 },
        { name: 'warehouseCounterpart', text: 'Kundenr.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'pickOrderNum', text: 'Lagerordre', widthType: FieldWidthEnum.S, visible: false },
        { name: 'customerRef', text: 'Kunderef.', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'purchOrderNum', text: 'Reference', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'orderStatus', text: 'Ordrestatus', tooltipText: 'Ordrens samlede status (linjestatus ses ikke)', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'product', fieldType: 'productLookup' },
        { name: 'productName', text: 'Titel', widthType: FieldWidthEnum.XXL, foreignKeyUsing: 'product' },
        { name: 'deliveredQty', text: 'Leveret antal', format: 'Integer' },
        { name: 'orderedQty', text: 'Lagerantal', format: 'Integer', visible: false },
        { name: 'salesQty', text: 'Antal', format: 'Integer', visible: false },
        { name: 'nameDlv', text: 'Navn', widthType: FieldWidthEnum.M },
        { name: 'streetDlv', text: 'Adresse', widthType: FieldWidthEnum.M },
        { name: 'zipCodeDlv', text: 'Postnr', widthType: FieldWidthEnum.XS },
        { name: 'cityDlv', text: 'Bynavn', widthType: FieldWidthEnum.XS },
        { name: 'countryRegionIdDlv', text: 'Land', widthType: FieldWidthEnum.XS, visible: false },
        { name: 'carrierTrackingNum', text: 'Track trace', widthType: FieldWidthEnum.L, urlBase: baseUrlTrackTrace },
        { name: 'weight', text: 'Vægt', format: 'Integer' },
        { name: 'inventLocationId', text: 'Lagersted' },
        { name: 'created', text: 'Oprettet', tooltipText: 'Oprettet dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'modified', text: 'Ændret', tooltipText: 'Ændret dato', allowEdit: false, format: 'DateLong', visible: false },
        { name: 'createdJobId', text: 'Oprettet job', format: 'Number', visible: false },
        { name: 'modifiedJobId', text: 'Ændret job', format: 'Number', visible: false }
      ]
    });
  }
}
